<template>
<div>
  <el-button
    v-for="item in items"
    :key="item.label"
    size="mini"
    @click="itemClick(item)"
  >
    {{ item.label }}
  </el-button>
</div>
</template>

<script>
export default {
  name: 'Operation',
  props: ['data', 'row', 'col'],
  computed: {
    items() {
      return (this.data || []).map((item) => ({
        label: item.label || item,
        value: item.value || item,
      }));
    },
  },
  methods: {
    itemClick(item) {
      this.$emit('click', item);
    },
  },
};
</script>

<style>

</style>
